import { Component, OnInit, AfterContentInit, NgZone } from '@angular/core';
import { WgisService } from './wgis/wgis.service';
import { WMAIApiService, Language, AppInformationService, AppStatus, RouterExtService, ExpLocalStorage } from './core';
import { NavigationEnd, Router } from '@angular/router';
import { AuthService, EvtSignIn } from './core/services/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { filter } from 'rxjs/operators';
import { environment } from '../environments/environment';
import { WGisDisplayMode } from './wgis/wgis.utils';
import { Angulartics2GoogleAnalytics } from 'angulartics2/ga';
import { BreakpointObserver } from '@angular/cdk/layout';
import { SuiModalService, TemplateModalConfig, ModalTemplate, ModalSize } from 'ng2-semantic-ui';
import { ConfirmModal } from 'src/app/core/templates';
import { Observable, Subscription, fromEvent } from 'rxjs';
import { Location, PathLocationStrategy } from '@angular/common';
import { version } from '../../package.json';

declare var gtag: any;
declare var $: any;
declare var device;
declare var universalLinks;
declare var window;
declare var StatusBar;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  isMapVisible = false;
  isUserLoggedIn = false;
  isAdmin = false;
  isSupervisor = false;
  username: string;
  selectedLanguage: string;
  currentUrl: string;
  languages: Language[] = [];
  isSmallScreen: boolean = false;
  isMobile: boolean = false;
  device = "";
  version: string = version;

  subscriptions: Subscription;

  connectionStatusMessage: string;
  connectionStatus: boolean;

  constructor(
    private auth: AuthService,
    public router: Router,
    private wmaiservice: WMAIApiService,
    private translateService: TranslateService,
    private wgisservice: WgisService,
    private breakpointObserver: BreakpointObserver,
    angulartics2GoogleAnalytics: Angulartics2GoogleAnalytics,
    private modalService: SuiModalService,
    private appService: AppInformationService,
    private expLocal: ExpLocalStorage,
    private previous: RouterExtService,
    private zone: NgZone,
    private pathLocationStrategy: PathLocationStrategy
  ) {


    const basePath = pathLocationStrategy.getBaseHref();
    const absolutePathWithParams = pathLocationStrategy.path();

    if (basePath !== absolutePathWithParams) {
      if (absolutePathWithParams.lastIndexOf('code=') > 0) {
        // console.log(absolutePathWithParams + absolutePathWithParams.lastIndexOf('='));
        // console.log(absolutePathWithParams.substring(absolutePathWithParams.lastIndexOf('=') + 1, absolutePathWithParams.length ));
        this.auth.loginIdm(absolutePathWithParams.substring(absolutePathWithParams.lastIndexOf('=') + 1, absolutePathWithParams.length));
      }
    }

    this.isSmallScreen = breakpointObserver.isMatched('(max-width: 768px)');
    this.connectionStatus = appService.getCurrentConnectionStatus();
    const navEndEvent$ = router.events.pipe(
      filter(e => e instanceof NavigationEnd)
    );
    navEndEvent$.subscribe((e: NavigationEnd) => {
      gtag('config', environment.googleAnalyticsKey, { 'page_path': e.urlAfterRedirects });
    });

    angulartics2GoogleAnalytics.startTracking();

    this.wgisservice.wgisVisible.subscribe((mode: WGisDisplayMode) => {
      this.isMapVisible = (mode !== WGisDisplayMode.Invisible);
    });

    this.appService.changeCurrentLanguage.subscribe(() => {
      this.selectedLanguage = this.appService.getDefaultLang();
    });

    this.appService.changeAppStatus(AppStatus.None);

    this.isUserLoggedIn = this.auth.isUserLoggedIn();
    if(this.isUserLoggedIn){
      this.username = this.auth.getIdUser();
      this.isAdmin = this.auth.getIsAdmin();
      this.isSupervisor = this.auth.getIsSupervisor();
    }
    auth.usersignedin.subscribe(
      (user: string) => {
        this.username = user;
        this.isUserLoggedIn = this.auth.isUserLoggedIn();
        this.isAdmin = this.auth.getIsAdmin();
        this.isSupervisor = this.auth.getIsSupervisor();
      }
    );
    auth.userlogout.subscribe(
      () => {
        this.username = '';
        this.isUserLoggedIn = false;
        this.isAdmin = false;
        this.isSupervisor = false;
        this.wgisservice.clearSelection();
        this.router.navigate(['/']);
      }
    );
    auth.userislogin.subscribe(
      (data: EvtSignIn) => {
        this.username = data.userid;
        this.isUserLoggedIn = true;
        this.selectedLanguage = data.locale;
        this.changeLanguage(this.selectedLanguage);
        this.isAdmin = this.auth.getIsAdmin();
        this.isSupervisor = this.auth.getIsSupervisor();
      }
    );
  }

  ngOnInit() {

    // $('.ui.sidebar').sidebar();
    // var userAgent = navigator.userAgent || navigator.vendor;
    // console.log(userAgent);
    // if (/iPad|iPhone|iPod/.test(userAgent) || /android/i.test(userAgent)) {
    //   console.log("UA: Running in Cordova/PhoneGap");
    //   console.log(navigator.userAgent);
    //   document.addEventListener("deviceready", (e) => {
    //     this.appService.setDeviceInfo(device.platform);
    //     this.isMobile = this.appService.iAmMobile();
    //     console.log(device.platform);
    //     document.addEventListener("backbutton", (event) =>{
    //       event.preventDefault();
    //       event.stopPropagation();
    //       this.redirect();
    //     }, false);
    //   });
    // } else {
    //     console.log("UA: Running in browser");
    //     this.appService.setDeviceInfo("browser");
    //     this.isMobile = this.appService.iAmMobile();
    // }
    this.appService.setDeviceInfo('browser');
    document.addEventListener("deviceready", (e) => {
      this.appService.setDeviceInfo(device.platform);
      this.isMobile = this.appService.iAmMobile();
      this.device = device.platform;
      if (this.device == "iOS") {
        StatusBar.overlaysWebView(false);
        StatusBar.backgroundColorByHexString("#1654ab");
      }
      window.FirebasePlugin.hasPermission(hasPermission => {
        if (!hasPermission && this.device == "iOS") {
          window.FirebasePlugin.grantPermission();
        }
      });
      // console.log(device.platform);
      document.addEventListener("backbutton", (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.redirect();
      }, false);
    });

    this.subscriptions = this.appService.onlineStatus.subscribe(data => {
      this.connectionStatus = data;
    });
    // console.log(this.connectionStatus);
    if (this.connectionStatus) {

      this.wmaiservice.getLanguages().subscribe(data => {
        let lang: string[] = [];
        for (let i = 0; i < data.length; i++) {
          lang.push(data[i].val);
          let tmp: Language = new Language(data[i].cat, data[i].val);
          this.languages.push(tmp);
        }
        this.translateService.addLangs(lang);
      });

      if (localStorage.getItem('locale') != null) {
        this.selectedLanguage = localStorage.getItem('locale');
      } else {
        this.selectedLanguage = 'it'
      }
      this.appService.changeDefaultLang(this.selectedLanguage);

      this.router.events.subscribe(event => {
        if (event instanceof NavigationEnd) {
          this.currentUrl = event.url;
        }
      });
    }
    this.syncMapLegend();

    this.auth.ctrLogIn();
  }

  redirect() {
    if (this.router.url != this.previous.getPreviousUrl()) {
      // console.log(this.previous.getPreviousUrl());
      this.zone.run(() => {
        this.router.navigateByUrl(this.previous.getPreviousUrl());
      });
    }
  }

  changeLanguage(language: string): void {
    this.selectedLanguage = language;
    if (this.isUserLoggedIn)
      this.wmaiservice.setLanguage(this.selectedLanguage, this.username).subscribe(data => data);

    this.appService.changeDefaultLang(language);
  }

  logout(e) {
    e.preventDefault();
    this.auth.logout();
    this.router.navigateByUrl('/');
    this.isUserLoggedIn = false;
    this.isAdmin = false;
    this.isSupervisor = false;
  }

  displaymap() {
    let notdisplayin: string[] = ['/faqs', '/register', '/login', '/resetpassword', '/settings', '/user', '/privacy', '/appstore', '/credit', '/help', '/contact'];
    if (notdisplayin.indexOf(this.currentUrl) == -1)
      this.wgisservice.cmdToggleMap();
    else
      this.wgisservice.setMapInvisible();
  }

  ngAfterViewInit() {
    $('.mobile.sidebar').sidebar('hide');
  }

  showSidebar() {
    $('.mobile.sidebar').sidebar('toggle');
  }


  onSyncCache() {
    this.modalService
      .open(new ConfirmModal("Attenzione", "Vuoi sincronizzare \ni contenuti presenti \nnella Cache?", ModalSize.Tiny))
      .onApprove(() => {
      })
      .onDeny(() => "");
  }

  onClearCache() {
    $('.mobile.sidebar').sidebar('toggle');
    let title = this.translateService.instant('modal.cache.title');
    let content = this.translateService.instant('modal.cache.clearCache');
    this.modalService
      .open(new ConfirmModal(title, content, ModalSize.Tiny))
      .onApprove(() => {
        this.expLocal.clearCache();
      })
      .onDeny(() => "");
  }

  checkScreen() {
    this.isSmallScreen = this.breakpointObserver.isMatched('(max-width: 768px)');
    return this.isSmallScreen;
  }

  onChangeConnStatus() {
    // console.log(this.connectionStatus);
    if (this.connectionStatus == false) this.router.navigate(['/downloaded/experience']);
  }

  syncMapLegend(){
    this.wmaiservice.getMapLegend().subscribe(data => {
        if(data){
          this.appService.setMapLegends(data);
        }
    }, error => {
        console.log('[Failed Sync - Map legend]');
    })
  }

}